<script setup>
import ApplicationLogo from "@/Components/ApplicationLogo.vue";

defineProps({
    modules: {
        type: Array,
        required: true,
    },
    eyebrow: {
        type: String,
        default: "Drie losse modules",
    },
    title: {
        type: String,
        default: "Kies wat u nodig heeft",
    },
    intro: {
        type: String,
        default: "Elke module werkt op zichzelf en koppelt rechtstreeks met Teamleader. Combineer ze als het past, of begin met één.",
    },
});
</script>

<template>
  <section class="bg-white py-20 sm:py-24">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl text-center">
        <p class="text-sm font-semibold uppercase tracking-wide text-indigo-600">
          {{ eyebrow }}
        </p>
        <h2 class="mt-3 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
          {{ title }}
        </h2>
        <p class="mt-4 text-lg text-gray-600">
          {{ intro }}
        </p>
      </div>
      <div class="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-8 lg:max-w-none lg:grid-cols-3">
        <article
          v-for="module in modules"
          :key="module.slug"
          class="flex flex-col rounded-3xl bg-white p-8 ring-1 ring-gray-200 transition hover:ring-indigo-300 hover:shadow-lg"
        >
          <div class="flex items-center gap-3">
            <ApplicationLogo :logo="module.slug" />
            <h3 class="text-xl font-semibold text-gray-900">
              {{ module.name }}
            </h3>
          </div>
          <p class="mt-3 text-sm font-medium text-indigo-600">
            {{ module.tagline }}
          </p>
          <p class="mt-4 text-base leading-7 text-gray-600">
            {{ module.description }}
          </p>
          <ul
            v-if="module.features && module.features.length"
            role="list"
            class="mt-6 space-y-2 text-sm text-gray-600"
          >
            <li
              v-for="feature in module.features"
              :key="feature"
              class="flex gap-x-2"
            >
              <svg
                class="h-5 w-5 flex-none text-indigo-600"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                  clip-rule="evenodd"
                />
              </svg>
              <span>{{ feature }}</span>
            </li>
          </ul>
          <a
            :href="module.href"
            target="_blank"
            rel="noopener noreferrer"
            class="mt-8 inline-flex items-center gap-1 text-sm font-semibold text-indigo-600 hover:text-indigo-500"
          >
            Bekijk {{ module.name }}
            <span aria-hidden="true">→</span>
          </a>
        </article>
      </div>
    </div>
  </section>
</template>
